var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCst = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9e16",
  d: "m11.913 12.073 9.26.11v-.111c0-5.011-4.068-9.074-9.087-9.074q-.086 0-.173.002z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0 1c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M12.21 6.524h-.305v7.127h.306z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M11.646 6.266h.823v7.644h-.823z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M17.631 11.826h-7.137v.306h7.137z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M10.235 11.567h7.655v.823h-7.655z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M12.211 3.007h-.308v2.124h.308z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M11.644 2.749h.826v2.64h-.826z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m7.656 4.158-.267.154 1.063 1.84.267-.154z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m7.035 4.217.716-.412 1.322 2.287-.715.413z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m4.287 7.43-.154.267 1.843 1.062.154-.267z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m3.78 7.792.413-.716 2.29 1.321-.413.715z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M5.135 11.946H3.008v.308h2.127z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M2.749 11.687h2.644v.826H2.75z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M6.004 15.432 4.16 16.495l.155.267 1.842-1.063z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m3.807 16.4 2.291-1.321.414.715-2.291 1.32z",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m8.501 18.02-1.063 1.84.267.153 1.063-1.84z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m7.084 19.954 1.323-2.288.715.413L7.8 20.367z",
  clipRule: "evenodd"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M12.268 19.013h-.309v2.124h.309z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M11.7 18.754h.826v2.641H11.7z",
  clipRule: "evenodd"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m15.719 17.992-.267.153 1.063 1.84.267-.154z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m15.098 18.05.715-.412 1.323 2.288-.716.413z",
  clipRule: "evenodd"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m18.196 15.383-.154.267 1.843 1.063.154-.267z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m17.689 15.746.413-.716 2.291 1.321-.413.716z",
  clipRule: "evenodd"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M21.164 11.89h-2.127v.308h2.127z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M18.778 11.63h2.644v.826h-2.644z",
  clipRule: "evenodd"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m19.857 7.381-1.842 1.063.154.267 1.843-1.062z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m17.66 8.35 2.292-1.322.413.715-2.29 1.321z",
  clipRule: "evenodd"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m16.466 4.13-1.064 1.84.268.154 1.063-1.84z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m15.049 6.064 1.323-2.287.715.412-1.323 2.288z",
  clipRule: "evenodd"
})));
export default SvgCst;